export function normalizeManualSalesOrder(soNumber, reason) {
  const so = String(soNumber ?? '').trim()
  const trimmedReason = String(reason ?? '').trim()
  if (!so) {
    return { soNumber: '', reason: '', error: null, active: false }
  }
  if (!/^\d{1,32}$/.test(so)) {
    return {
      soNumber: so,
      reason: trimmedReason,
      error: 'SO Number must be 1 to 32 digits',
      active: true,
    }
  }
  if (!trimmedReason) {
    return {
      soNumber: so,
      reason: '',
      error: 'A reason is required when an SO Number is entered',
      active: true,
    }
  }
  return { soNumber: so, reason: trimmedReason, error: null, active: true }
}
